import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/Button';
interface GalleryPageProps {
  setPage: (page: string) => void;
}
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
export function GalleryPage({
  setPage
}: GalleryPageProps) {
  // Placeholder gallery data
  const galleryItems = [{
    id: 1,
    image: 'https://cdn.magicpatterns.com/uploads/eHHZJxJDP1g4XtDm97PGqt/Car.png',
    title: 'Classic Car Frame Restoration',
    service: 'Automotive Blasting',
    location: 'Fowlerville, MI'
  }, {
    id: 2,
    image: 'https://cdn.magicpatterns.com/uploads/nwszFkSK7z7YzcXejibz5t/industrial.png',
    title: 'Heavy Machinery Paint Removal',
    service: 'Industrial Equipment',
    location: 'Lansing, MI'
  }, {
    id: 3,
    image: 'https://cdn.magicpatterns.com/uploads/oFDsSkJrmNAJ6a3LCdu5Z8/brick.png',
    title: 'Historic Brick Graffiti Removal',
    service: 'Concrete & Brick',
    location: 'Detroit, MI'
  }, {
    id: 4,
    image: 'https://cdn.magicpatterns.com/uploads/eHSGTvKiEKDoyNeGiJEQre/farm.png',
    title: 'Farm Tractor Rust Removal',
    service: 'Agricultural Equipment',
    location: 'Grand Rapids, MI'
  }, {
    id: 5,
    image: 'https://cdn.magicpatterns.com/uploads/48bCEVVaL61jN9XD41Jxcj/truck.png',
    title: 'Commercial Fleet Truck Prep',
    service: 'Automotive Blasting',
    location: 'Ann Arbor, MI'
  }, {
    id: 6,
    image: 'https://cdn.magicpatterns.com/uploads/5oGYwNQ7aCvj8my8QTrVPS/beam.png',
    title: 'Steel Beam Coating Removal',
    service: 'Industrial Blasting',
    location: 'Flint, MI'
  }];
  return <div className="w-full bg-white" data-id="element-235">
      {/* Header */}
      <section className="bg-charcoal pt-20 pb-16 px-4" data-id="element-236">
        <div className="max-w-7xl mx-auto text-center" data-id="element-237">
          <motion.h1 initial="hidden" animate="visible" variants={fadeInUp} className="text-4xl md:text-6xl font-heading font-extrabold text-white uppercase tracking-tight mb-4" data-id="element-238">
            Project <span className="text-brand-red" data-id="element-239">Gallery</span>
          </motion.h1>
          <motion.p initial="hidden" animate="visible" variants={fadeInUp} className="text-lg text-steel-300 font-body max-w-2xl mx-auto" data-id="element-240">
            Real projects. Real transformations. See the difference our dustless
            and dry blasting services make.
          </motion.p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 px-4 bg-steel-50" data-id="element-241">
        <div className="max-w-7xl mx-auto" data-id="element-242">
          <motion.div initial="hidden" animate="visible" variants={staggerContainer} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-243">
            {galleryItems.map(item => <motion.div key={item.id} variants={fadeInUp} className="bg-white border border-steel-200 overflow-hidden group" data-id="element-244">
                <div className="relative h-64 overflow-hidden bg-charcoal" data-id="element-245">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" data-id="element-246" />
                </div>
                <div className="p-6" data-id="element-247">
                  <h3 className="font-heading font-bold text-xl uppercase text-charcoal mb-2 group-hover:text-brand-red transition-colors" data-id="element-248">
                    {item.title}
                  </h3>
                  <div className="flex justify-between items-center text-sm" data-id="element-249">
                    <span className="text-steel-600 font-medium" data-id="element-250">
                      {item.service}
                    </span>
                    <span className="text-steel-400" data-id="element-251">{item.location}</span>
                  </div>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white text-center px-4 border-t border-steel-200" data-id="element-252">
        <div className="max-w-3xl mx-auto" data-id="element-253">
          <h2 className="text-3xl font-heading font-extrabold uppercase text-charcoal mb-6" data-id="element-254">
            Have a Similar Project?
          </h2>
          <p className="text-steel-600 mb-8 text-lg" data-id="element-255">
            Whether it's a small automotive frame or a massive industrial
            facility, we have the equipment and expertise to handle it.
          </p>
          <Button variant="primary" size="lg" onClick={() => setPage('contact')} data-id="element-256">
            Get a Free Estimate
          </Button>
        </div>
      </section>
    </div>;
}